<div class="code-verification-container">
  <c-otp-input
    [label]="'verification-code.otp.label' | transloco"
    [length]="otpLength"
    [allowNumbersOnly]="true"
    [inputStyles]="inputStyles"
    [locked]="checkState() === 'valid'"
    [formControl]="control"/>

  @switch (checkState()) {
    @case ('verifying') {
      <div class="code-verification__status code-verification__status--verifying">
        <ion-spinner name="crescent" />
        {{ 'verification-code.verifying' | transloco }}
      </div>
    }
    @case ('valid') {
      <div class="code-verification__status code-verification__status--valid" role="status">
        <c-icon [icon]="validIcon" />
        {{ 'verification-code.valid' | transloco }}
      </div>
    }
    @case ('invalid') {
      <div class="code-verification__status code-verification__status--invalid" role="alert">
        <c-icon [icon]="invalidIcon" />
        {{ 'verification-code.invalid' | transloco }}
      </div>
    }
  }

  <!-- An accepted code is final: nothing left to resend. -->
  @if (checkState() !== 'valid') {
    @if (countdown$ | async; as countdown) {
      <div>{{ 'verification-code.resend-link.timeout' | transloco }} {{ countdown * 1000 | date: 'mm:ss' }}</div>
    } @else {
      <c-button type="secondary" (action)="onSendVerificationCode()">
        {{ 'verification-code.resend-link' | transloco }}
      </c-button>
    }
  }
</div>
